import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import SearchBar from "../../SearchBar";
import { useAuth } from "../../../context/AuthContext";
import UserMenu from "./userMenu";

const HeaderWrapper = styled.header`
  width: 100%;
  background-color: #f7f7f7;
  /* border-bottom: 1px solid #062541; */
  padding: 10px 5px;
  position: fixed;
  top: 0;
  left: 75px;
  z-index: 100;
`;

const NavMenus = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  margin-right: 90px;
  padding: 0;
  gap: 15px;
`;

const SearchContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
`;

const HeaderV2 = () => {
  const { linkToken, currentUser } = useAuth();

  return (
    <>
      <HeaderWrapper>
        <Container fluid className="p-0">
          <Row className="align-items-center justify-content-between">
            <Col className="d-flex justify-content-between align-items-center">
              <SearchContainer>
                <SearchBar />
              </SearchContainer>
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column align-items-end mr-3">
                  <h6 className="f-14 font-weight-bold mb-0">
                    {currentUser.user.nombre} {currentUser.user.apellido}
                  </h6>
                  <p className="m-0">{currentUser.user.Pi.puesto}</p>
                </div>
                {!linkToken && (
                  <NavMenus>
                    <UserMenu />
                  </NavMenus>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </HeaderWrapper>
    </>
  );
};

export default HeaderV2;
